module.exports = __webpack_public_path__ + "static/vanishing-words-adac40aea54639e10db0dee519e0128b.jpg";